import { watchEffect } from "vue";
import { RouteLocationNormalized } from "vue-router";
import router from "@/router";
// import { Auth } from "aws-amplify";
import { fetchAuthSession, signInWithRedirect } from "aws-amplify/auth";
import { get } from "aws-amplify/api";

async function useRouteGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) {
  fetchAuthSession()
    .then((user) => {
      if (user.tokens?.idToken?.payload.identities) {
        return true;
      } else {
        if (to.name == "EnableMFA") {
          return true;
        }
      }
      return true;
    })
    .catch(() => {
      signInWithRedirect();
      return false;
    });
}

export { useRouteGuard };
